import { Pipe, PipeTransform } from '@angular/core';

const MIN_PERCENT_THRESHOLD_VALUE = 0.01;

@Pipe({
    name: 'adcPercent',
})
export class AdcPercentPipe implements PipeTransform {
    transform(value: number, precision = 0, smallPrecision = 0, naStr?: string): string {
        if (value == undefined || Number.isNaN(value)) {
            if (naStr !== undefined) {
                return naStr;
            } else {
                return '0%';
            }
        }

        const formatedValue = value.toFixed(value > 1 ? precision : smallPrecision);

        if (0 < value && value < MIN_PERCENT_THRESHOLD_VALUE) {
            return `<${MIN_PERCENT_THRESHOLD_VALUE}%`;
        }

        return formatedValue + '%';
    }
}
